document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.slideshow__slide').forEach(slide => {
    const link = slide.querySelector('a');
    if (link) {
      slide.addEventListener('click', () => {
        window.location.href = link.href;
      });
      slide.style.cursor = 'pointer';
    }
  });
});
